import instance from "./instance";
import instanceNew from "./instance-new";
import Api from "../config/Api";

import { aesUtil } from "../helpers/encryptionMail";

export const callTestApi = async () => {
	return instance.get("/activity");
};

export const getPersonalDetails = async(data ,businessLine = null) => {
	////     // console.log("personadetails", data);
	return instanceNew.post(`travel/getTravelPersonal`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getRenewalDetails = async (data, businessLine = null) => {
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/getPolicyDetails`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getProfessionalList = async (data,businessLine = null) => {
	////     // console.log("professionallistInput", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/profession`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getKYCProfessionalList = async (data,businessLine = null) => {
	////     // console.log("professionallistInput", data);
	return instanceNew.post(Api.getProfession, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getCity = async (data,businessLine = null) => {
	////     // console.log("cityinput", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/city`, data, {
		headers: { "content-type": "application/json" },
	});
};

export const getKYCCity = async (data,businessLine = null) => {
	return instanceNew.post(Api.getCity, data, {
		headers: { "content-type": "application/json" },
	});
};

export const getRegion = async (data,businessLine = null) => {
	////     // console.log("region", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/region`, data, {
		headers: { "content-type": "application/json" },
	});
};
export const getNationality = async (data,businessLine = null) => {
	////     // console.log("nation", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/nationlity`, data, {
		headers: { "content-type": "application/json" },
	});
};

export const getPeriodofInsurance = async (data,businessLine = null) => {
	////     // console.log("periodofinsurance", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/policyPeriod`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getPolicyCardPrice = async (data,businessLine = null) => {
	if (!data.period) data.period = "1";
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/price`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getAnnualClaim = async (data,businessLine = null) => {
	////     // console.log("AnnualClaim", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/indemnity`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getNameofInsurerList = async (data,businessLine = null) => {
	////     // console.log("nameofInsurer", data);
	// return instance.post(
	// 	"/medicalMalpractice/nameofInsurer",
	// 	data,
	// 	{ headers: { "Content-Type": "application/json" }}
	// );
	return {
		status: 200,
		data: {
			status: "Success",
			resultCode: "S",
			resultMessage: "Success",
			companyDetails: [
				{
					companyCode: "1",
					companyName: "Acig",
				},
				{
					companyCode: "2",
					companyName: "Walaa",
				},
				{
					companyCode: "3",
					companyName: "Alrajhi Takaful",
				},
				{
					companyCode: "4",
					companyName: "Gulf General ",
				},
				{
					companyCode: "5",
					companyName: "Tamkeen ",
				},
				{
					companyCode: "6",
					companyName: "Alahliha ",
				},
				{
					companyCode: "7",
					companyName: "Other ",
				},
			],
		},
	};
};

export const getCreateQuotationt = async (data,businessLine = null) => {
	////     // console.log("CreateQuotationtdata", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/createQuotation`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getQuotationDetails = async (data,businessLine = null) => {
	////     // console.log("CreateQuotationtdata", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/quotationDetails`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getrenewalQuotation = async (data,businessLine = null) => {
	////     // console.log("CreateQuotationtdata", data);
	return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/renewalQuotation`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getPolicyNumberId = async (data,businessLine = null) => {
	return instance.post(`${businessLine ? `${businessLine}` : ""}/payment/getPaymentById`, data, {
		headers: { "Content-Type": "application/json" },
	});
};

export const getSadadPayment = async (data,businessLine = null) => {
	return {
		status: 200,
		data: {
			resultCode: "S",
			billNo: "1212416786",
			billExpiryDate: "20/06/2022",
			policyNumber: "7689076543",
			resultMessage: "Invalid",
		},
	};
};

export const validatePromoCode = async (reqData, businessLine = null) => {
	try {
		const { data } = await instance.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/getPromoCode`, reqData)
		if (data) return data
		else Promise.reject({ msg: 'Failed to Apply Promocode' })
	} catch (error) {
		Promise.reject(error)
	}
};
export const getCardPayment = async (data,businessLine = null) => {
	return {
		status: 200,
		data: {
			resultCode: "S",
			redirectUrl: "http://localhost:3000/medmal/success",
			resultMessage: "Invalid",
		},
	};
};
export const createTamaraSession = async (data,businessLine = null) => {
	return {
		status: 200,
		data: {
			resultCode: "S",
			redirectUrl: "http://localhost:3000/medmal/success",
			resultMessage: "Invalid",
		},
	};
};
export const sendEnquiry = async (reqData) => {
	try {
		let encrypted = aesUtil.encrypt(process.env.REACT_APP_ENC_VERSION, JSON.stringify(reqData));
		const config = {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: encrypted,
		};
		const response = await fetch(process.env.REACT_APP_API_URL + "/common/sendEmail", config);
		const json = await response.json();
		// console.log(json);
		if (json.statusDescription === "Success") return Promise.resolve("Success");

		//
		// const { data } = await instanceNew.post("common/sendEmail", reqData);
		// if (data.statusDescription === "Success") return Promise.resolve("Success");
	} catch (error) {
		return Promise.reject(error);
	}
};

export const initiateMedicalMalpracticeRenew = async (data,businessLine = null) => {
  return instanceNew.post(`${businessLine ? `${businessLine}` : ""}/medicalMalpractice/initiateMMRenew`, data, {
    headers: { "Content-Type": "application/json" },
  });
};


const MedmalService = {
	callTestApi,
	getPersonalDetails,
	getProfessionalList,
	getPeriodofInsurance,
	getPolicyCardPrice,
	getNameofInsurerList,
	getCreateQuotationt,
	getrenewalQuotation,
	getCity,
	getRegion,
	getNationality,
	getSadadPayment,
	getCardPayment,
	createTamaraSession,
	sendEnquiry,
	validatePromoCode,
	initiateMedicalMalpracticeRenew,
};

export default MedmalService;
